module.exports = __webpack_public_path__ + "img/quote-close.f3833b99.png";